import styled from 'styled-components';

const ButtonToggleTheme = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  color: var(--on-background);
  display: flex;
  align-items: center;
  margin: 0 16px;
  font-size: 36px;
`;

export default ButtonToggleTheme;
